<script lang="ts">
  import { isLoggedIn } from '$lib/auth.svelte';
  import { openFeedback } from '$shared/feedback.svelte';

  // Re-show daily — `Date.now() - dismissedAt > 24h`. Lets us reach test users
  // again the next day without nagging them in the same session.
  const STORAGE_KEY = 'beta_banner_dismissed_at';
  const HIDE_WINDOW_MS = 24 * 60 * 60 * 1000;

  function readDismissed(): number {
    if (typeof localStorage === 'undefined') return 0;
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? Number(raw) : 0;
  }

  let dismissedAt = $state(readDismissed());
  const visible = $derived(isLoggedIn() && Date.now() - dismissedAt > HIDE_WINDOW_MS);

  function dismiss(): void {
    const now = Date.now();
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, String(now));
    }
    dismissedAt = now;
  }
</script>

{#if visible}
  <div class="beta-banner" role="status" aria-label="Private beta banner">
    <span class="beta-text">
      Private beta — expect rough edges. Found something?
      <button type="button" class="beta-cta" onclick={openFeedback}> Tell us &rarr; </button>
    </span>
    <button type="button" class="beta-dismiss" aria-label="Dismiss banner" onclick={dismiss}> × </button>
  </div>
{/if}

<style>
  .beta-banner {
    position: relative;
    padding: 6px 36px 6px 12px;
    background: linear-gradient(90deg, #c93494, #5c2ba6);
    color: #fff;
    font-size: 13px;
    line-height: 1.4;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    text-align: center;
  }
  .beta-text {
    display: inline-block;
    max-width: 700px;
  }
  .beta-cta {
    background: transparent;
    border: none;
    color: #fff;
    font-weight: 700;
    text-decoration: underline;
    cursor: pointer;
    padding: 0 4px;
    font-size: inherit;
  }
  .beta-cta:hover {
    filter: brightness(1.15);
  }
  .beta-dismiss {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: none;
    color: #fff;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    padding: 4px 8px;
    opacity: 0.7;
  }
  .beta-dismiss:hover {
    opacity: 1;
  }
</style>
